import script from "./OnboardingContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingContainer.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingContainer.vue?vue&type=style&index=0&id=d46334f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d46334f0"]])

export default __exports__